export enum Feature {
  AllCourseModulesUnlocked = 'all_course_modules_unlocked',
  AllowSkipPurchaseFlow = 'allow_skip_purchase_flow',
  CameraAutoFocus = 'camera_auto_focus',
  CoachHubAddonsAlwaysShowPrice = 'coach_hub_addons_always_show_price',
  CoachHubCoachCardMessageButton = 'coach_hub_coach_card_message_button',
  CoachRating = 'coach_rating',
  ChatbotFileAttachments = 'chatbot_file_attachments_mobile',
  ChatbotMessageReporting = 'chatbot_message_reporting_mobile',
  DirectS3MealUpload = 'direct_s3_meal_upload_mobile',
  EmbedKustomerSupportForm = 'embed_kustomer_support_form',
  FullscriptLabs = 'fullscript_labs_mobile',
  InAppVideoCallsSignUp = 'in_app_video_calls_sign_up',
  IncludeCurrentDayInHealthDataSubmission = 'include_current_day_in_health_data_submission',
  InsuranceCardSubmission = 'insurance_card_submission',
  InsuranceCoveredVideoConsult = 'insurance_covered_video_consult',
  InsuranceResubmission = 'insurance_resubmission',
  IntercomMessengerForMultipleAssignments = 'intercom_messenger_for_multiple_assignments',
  MedicalDisclaimerSurvey = 'medical_disclaimer_survey',
  MemberNotes = 'member_notes_mobile',
  MentalHealthServicesInterestSurvey = 'mental_health_services_interest_survey',
  MfpPromotion = 'mfp_promotion',
  MicrobiomeTest = 'microbiome_test_mobile',
  MobileAppPresentationMode = 'mobile_app_presentation_mode_mobile',
  MoveDailyMeasurementsToEnd = 'move_daily_measurements_to_end',
  NewProgramDurationDesign = 'new_program_duration_design',
  NewProgramSelectionContent = 'new_program_selection_content',
  NewRatings = 'new_ratings_mobile',
  NotificationInbox = 'notification_inbox_v1_mobile',
  NoraBlockReports = 'nora_block_reports',
  NoraRealtimeVoiceMode = 'nora_realtime_voice_mode_mobile',
  NutritionistMenuProductsSequence = 'nutritionist_menu_products_sequence_mobile_fresh',
  OnboardingExperience = 'onboarding_experience_mobile',
  OutcomesTracking = 'outcomes_tracking',
  OwnSensorActivatedVideoCallsUpsell = 'own_sensor_activated_video_calls_upsell',
  PlatformPayButton = 'platform_pay_button',
  PopulateMealTimeFromPhoto = 'populate_meal_time_from_photo',
  RdsSwitchWhenRdIsLeaving = 'rd_switch_when_rd_is_leaving',
  RecurringAppointmentsScheduling = 'recurring_appointments_scheduling_mobile',
  SatisfactionRatingSurvey = 'satisfaction_rating_survey',
  SavePhotoToCameraRoll = 'save_photo_to_camera_roll',
  ServiceCentricAppointmentScheduler = 'service_centric_appointment_scheduler',
  ShowMealTimeTooltip = 'show_meal_time_tooltip',
  ShowTwoSteloUnits = 'show_two_stelo_units',
  SkipProgramSelectionBeforeSignUp = 'skip_program_selection_before_sign_up',
  SteloCgmAddonOffer = 'stelo_cgm_addon_offer',
  SteloLimitedOfferPromoTag = 'stelo_limited_offer_promo_tag',
  SteloRealtimeCalibration = 'stelo_realtime_calibration',
  StartDexcomParticipation = 'start_dexcom_participation',
  SubscriptionChangeBillingCycle = 'subscription_change_billing_cycle',
  SubscriptionPausing = 'subscription_pausing',
  SurveysCustomSlideComponents = 'surveys_custom_slide_components',
  SyncActionGoalsFromMacros = 'sync_action_goals_from_macros',
  TerraKetoMojo = 'terra_ketomojo',
  UkSupport = 'uk_support',
  UnifiedAppointmentBookingFlow = 'unified_appointment_booking_flow_mobile',
  VideoCallCredits = 'video_call_credits',
  VideoCallSchedulingOptions = 'video_call_scheduling_options_mobile',
  VideoCallsEarlierAvailableSlotsCheck = 'video_calls_earlier_available_slots_check',
  VideoCallsSteloUpsell = 'cgm_upsell',
  AppointmentSchedulerMonthlyDateFetching = 'appointment_scheduler_monthly_date_fetching',
}

export interface FeatureFlagProps {
  feature: Feature
  children: any
  fallbackComponent?: React.ReactNode
}
